import _filter from "lodash/filter";
import _includes from "lodash/includes";
import _isEmpty from "lodash/isEmpty";
import _map from "lodash/map";
import { TFunction } from "i18n";
import { FacetCategory, IGetFacetsResponse } from "shared-types/src/Facets";
import { getFacetListByType } from "shared-utils/src/utils/facets/lists/getFacetListByType";
import { formatListWithMore } from "pages/JobsPage/components/RolePreferences/helpers/formatListWithMore";

interface MapProductionTypesProps {
  facets: IGetFacetsResponse;
  productionTypeIds: number[];
  anyProductionType?: boolean;
  t: TFunction;
}

export function mapProductionTypes({
  facets,
  productionTypeIds,
  anyProductionType,
  t,
}: MapProductionTypesProps): string {
  if (anyProductionType) {
    return t("common:jobs.page.rolePreferences.productionTypes.anyDescription");
  }

  if (_isEmpty(facets) || _isEmpty(productionTypeIds)) {
    return "";
  }

  const productionTypeFacets = getFacetListByType(
    facets,
    FacetCategory.ProductionType
  );

  const selectedProductionTypeNames = _map(
    _filter(productionTypeFacets, ({ id }) => _includes(productionTypeIds, id)),
    "name"
  );

  return formatListWithMore(selectedProductionTypeNames, t);
}
